import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, IconButton, Typography } from '@mui/material';
import { Close, NotificationsActiveOutlined } from '@mui/icons-material';

import { ROUTES } from 'consts';

export const SuspendServiceSuccessPage = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ paddingX: 3, paddingY: 2.5, display: 'flex', alignItems: 'center' }}>
      <NotificationsActiveOutlined sx={{ color: (theme) => theme.palette.primary.main }} />

      <Typography variant="body2" color="textSecondary" sx={{ marginLeft: 2 }}>
        The service interruption has been successfully submitted.
      </Typography>

      <IconButton
        size="small"
        color="primary"
        sx={{ marginLeft: 'auto' }}
        onClick={() => navigate(ROUTES.HOME, { replace: true })}
      >
        <Close />
      </IconButton>
    </Box>
  );
};
